import TYPES from '@/modules/shared/types';

// Domain
import {
  BaseGoalsRepository,
} from '@/modules/flagship/investor-goal/base-goals/domain/repositories/base-goals-repository';
import {
  BaseGoalsDto,
} from '@/modules/flagship/investor-goal/base-goals/domain/dtos/base-goals-dto';
import HttpConnector from '@/modules/shared/domain/connectors/http';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';

@Injectable()
export default class BaseGoalsHttpRepository implements BaseGoalsRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-goal/base-goals/`;

  update(base_goals_dto: BaseGoalsDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', base_goals_dto)
        .then((response) => {
          if (response.ok) {
            resolve();
          } else {
            response.json().then(
              ({ message }) => reject(new Error(message)),
            );
          }
        })
        .catch(reject);
    });
  }
}
